import { render } from "./user-asset-details.vue?vue&type=template&id=7a747986"
import script from "./user-asset-details.vue?vue&type=script&lang=js"
export * from "./user-asset-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__